import { Button, Icon, pxToRem } from '@lbcamden/lib-react';
import { FunctionComponent } from 'react';

import { useRoleInformation } from '~/client/hooks/storeHooks';

import { CompletionActionNoticeRoot } from './CompletionActionNotice.styled';

type Props = {
  hasSubmitted?: boolean;
  canApprove?: boolean;
  isApproving?: boolean;
  onClickApprove(): void;
  onClickSubmit(): void;
};

export const CompletionActionNotice: FunctionComponent<Props> = ({
  hasSubmitted,
  canApprove,
  isApproving,
  onClickApprove,
  onClickSubmit,
}) => {
  const { isPcfraManager } = useRoleInformation();

  const canSubmit = !hasSubmitted && !isPcfraManager;
  const hasAction = canSubmit || canApprove;

  if (!hasAction) {
    return null;
  }

  return (
    <CompletionActionNoticeRoot>
      {canSubmit && (
        <>
          Would you like to submit this PCFRA for approval?
          <Button $mobileStretch $color="dartmouthGreen" onClick={onClickSubmit}>
            Submit for Approval
          </Button>
        </>
      )}
      {canApprove && (
        <>
          Would you like to approve this PCFRA?{'\n'}
          {!hasSubmitted && 'It has not been formally submitted for approval yet'}
          <Button
            $mobileStretch
            $color="dartmouthGreen"
            loading={isApproving}
            onClick={onClickApprove}
          >
            <Icon icon="ui/tick" width={pxToRem(14)} />
            Approve PCFRA
          </Button>
        </>
      )}
    </CompletionActionNoticeRoot>
  );
};
